module.exports = __webpack_public_path__ + "static/media/TaskManagement_admin_002.d8fe7af5.png";